import React from 'react';

import { archiveTypes } from '@vlabs/shared/config';
import { selectIsAppFeatureAvailable } from '@vlabs/shared/selectors/appSelectors';
import { selectListOptions } from '@vlabs/shared/selectors/listSelectors';
import validate from '@vlabs/shared/validators';
import { Divider, Control } from '@vlabs/uikit';
import { useFormContext, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import st from './StepPackageImport.module.sass';

function StepPackageImport(): React.JSX.Element {
  const { t } = useTranslation();
  const { control, register } = useFormContext();
  const isFaceQualityAvailable = useSelector((state) => selectIsAppFeatureAvailable(state, 'estimations.face_quality'));
  const listOptions = useSelector(selectListOptions);
  const { errors } = useFormState();

  return (
    <React.Fragment>
      <h6>{t('monokit:entities.handlers.ui.steps.step package import.title')}</h6>
      <Divider />
      <Control.FileInput
        label={t('monokit:entities.handlers.ui.steps.step package import.file input.label') as unknown as string}
        {...register('content.source.file.reference', {
          required: validate.required(),
          validate: (file) => {
            if (!archiveTypes.includes(file[0].type)) {
              return t('monokit:entities.handlers.ui.steps.step package import.file input.validation message') as unknown as string;
            }
            return true;
          },
        })}
        errors={errors}
      />

      <Divider small />

      <Control.Select
        autoFocus
        control={control}
        errors={errors}
        id="content.handler.policies.storage_policy.face_policy.link_to_lists_policy.0.list_id"
        isCreatable
        label={t('monokit:entities.handlers.ui.steps.step package import.list select.label') as unknown as string}
        name="content.handler.policies.storage_policy.face_policy.link_to_lists_policy.0.list_id"
        options={listOptions}
        rules={{ required: validate.required(), validate: validate.uuidOptions }}
      />

      <Divider small />

      {!!isFaceQualityAvailable && (
        <div
          className={st.Switch}
        >
          <div className={st.Switch__Label}>{t('monokit:entities.handlers.ui.steps.step package import.face quality switch.label')}</div>
          <Control.Switch
            control={control}
            name="content.handler.policies.detect_policy.face_quality.estimate"
          />
        </div>
      )}

      <Divider small />
    </React.Fragment>
  );
}

StepPackageImport.fieldNames = [
  'content.source',
  'content.handler',
];

export { StepPackageImport };
